export default __webpack_public_path__ + "static/media/316.91be4e0d.png";